import { createSlice, current } from "@reduxjs/toolkit";


const initialState = {
    data: {
        department: [],
        employee: {
            results: []
        },
        supplier: [],
        mastereditemp: [],
    },
    loading: false,
    error: null,
};

const teamManagementSlice = createSlice({
    name: 'department',
    initialState,
    reducers: {

        // Loading .... 

        start(state) {
            state.loading = true;
            state.error = null;
        },
        failure(state, action) {
            state.loading = false;
            state.error = action.payload;
        },

        // Department store ...... 

        getDepartmentSuccess(state, action) {
            state.loading = false;
            state.data.department = action.payload;
        },
        addDepartment(state, action) {
            state.loading = false;
            state.data.department.results.push(action.payload);
        },
        updateDepartment(state, action) {
            state.loading = false;
            const index = state.data.department.results.findIndex(e => e.id === action.payload.id);
            state.data.department.results[index] = action.payload
        },

        // Employee store .......

        getEmployeeSuccess(state, action) {
            state.loading = false;
            state.data.employee.results = action.payload.results;
        },
        addEmployee(state, action) {
            state.loading = false;
            state.data.employee.results.push(action.payload);
        },
        updateEmployee(state, action) {
            state.loading = false;
            const index = state.data.employee.results.findIndex(e => e.id === action.payload.id);
            state.data.employee.results[index] = action.payload
        },
        deleteEmployee(state, action) {
            state.loading = false;
            const filteredData = state.data.employee.results.filter(e => e.id !== action.payload);
            state.data.employee.results = filteredData;
        },
        
       


        // Supplier store .......

        getSupplierSuccess(state, action) {
            state.loading = false;
            state.data.supplier = action.payload;
        },
        addSupplier(state, action) {
            state.loading = false;
            state.data.supplier.results.push(action.payload);
        },
        updateSupplier(state, action) {
            state.loading = false;
            const index = state.data.supplier.results.findIndex(e => e.id === action.payload.id);
            state.data.supplier.results[index] = action.payload
        },
        deleteSupplier(state, action) {
            state.loading = false;
            const filteredData = state.data.supplier.results.filter(e => e.id !== action.payload);
            state.data.supplier.results = filteredData;
        },


        // Master edit employee data .....
        getMasterEditEmpSuccess(state, action) {
            state.loading = false;
            state.data.mastereditemp = action.payload;
        },
    },
});

export default teamManagementSlice.reducer;
export const {
    start,
    getDepartmentSuccess,
    failure, addDepartment,
    updateDepartment,
    getEmployeeSuccess,
    addEmployee, updateEmployee,
    deleteEmployee,
    getMasterEditEmpSuccess,
    getSupplierSuccess,
    addSupplier,
    updateSupplier,
    deleteSupplier,
     } = teamManagementSlice.actions;